(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jericho-help-widget"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const widget = document.getElementById('jl-support-widget');
    if (widget?.open && !widget.contains(event.target)) {
      widget.open = false;
    }
  });

  document.addEventListener('keydown', (event) => {
    const widget = document.getElementById('jl-support-widget');
    if (event.key === 'Escape' && widget?.open) {
      widget.open = false;
      widget.querySelector('summary')?.focus();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jericho-order-tracking"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', function(event) {
    const form = event.target;

    if (form.id !== 'jl-order-form') return;

    event.preventDefault();

    const input = form.querySelector('#jl-order-input');
    const numero = input.value.trim();

    if (!numero) {
      input.focus();
      return;
    }

    const mensaje =
      'Hola, quiero consultar el estado de mi pedido ' +
      numero +
      ' de JERICHO LABEL.';

    const url =
      'https://wa.me/573117259861?text=' +
      encodeURIComponent(mensaje);

    window.location.href = url;
  });
  } catch(e) { console.error(e); }
})();

})();
